import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { onEscKeyPressOnDialog } from 'pages/ProjectsPage/WorkspacePage/components/Common/utils'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    dialogTitle: {
        '& .MuiTypography-h6': {
            color: '#304959',
            fontSize: pxToRem(34),
        },
        '&.MuiDialogTitle-root': {
            padding: theme.spacing(2, 0),
        },
        maxWidth: pxToRem(510),
    },

    dialogWrapper: {
        '& .MuiDialog-paperScrollPaper': {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
            width: pxToRem(560),
            height: pxToRem(203),
        },
    },
    closeDialogActionText: {
        fontSize: pxToRem(18),
        color: '#1899D4',
        fontWeight: 500,
        cursor: 'pointer',
    },
    dialogAction: {
        '&.MuiDialogActions-root': {
            padding: theme.spacing(2.5, 2.5, 3),
        },
    },
    dialogContent: {
        padding: theme.spacing(1, 0),
        overflow: 'hidden',
        color: theme.palette.common.black,
        fontSize: pxToRem(14),
        borderTop: 'none',
        borderBottom: 'none',
        maxWidth: pxToRem(480),
    },
}))

export interface MOPTRestrictionDialogProps {
    /**
     * Defines state of confirmation dialog.
     */
    open: boolean

    /**
     * For closing confirmation dialog
     */
    onClose: VoidFunction

    /**
     * The title of the dialog (e.g., "Add Disabled", "Move Disabled")
     */
    title: string

    /**
     * The description/body of the dialog
     */
    description: string
}

/**
 * A reusable dialog component for displaying Manufacturer-sourced Product Type (MOPT) restrictions.
 * This component matches the styling of the Product Type Deactivation Warning dialog.
 */
export const MOPTRestrictionDialog = ({
    open,
    onClose,
    title,
    description,
}: MOPTRestrictionDialogProps) => {
    const classes = useStyles()

    return (
        <Dialog
            open={open}
            data-testid="mopt-restriction-dialog"
            onClose={onEscKeyPressOnDialog(onClose)}
            className={classes.dialogWrapper}
        >
            <DialogTitle className={classes.dialogTitle}>{title}</DialogTitle>
            <DialogContent
                className={classes.dialogContent}
                data-testid="dialogContent"
            >
                {description}
            </DialogContent>

            <DialogActions className={classes.dialogAction}>
                <Typography
                    onClick={onClose}
                    className={classes.closeDialogActionText}
                    data-testid="close-mopt-restriction-dialog"
                >
                    Close
                </Typography>
            </DialogActions>
        </Dialog>
    )
}
